export enum PaymentMethodType {
  MobilePay = 'mobilepay',
  Stripe = 'stripe',
}
